export const DashboardActionTypes = {
  UPDATE_DASHBOARD_BASIC_DATA: '@dashboard/UPDATE_DASHBOARD_BASIC_DATA',
  UPDATE_DASHBOARD_BASIC_DATA_SUCCEEDED:
    '@dashboard/UPDATE_DASHBOARD_BASIC_DATA_SUCCEEDED',
  UPDATE_DASHBOARD_BASIC_DATA_FAILED: '@dashboard/UPDATE_DASHBOARD_BASIC_DATA_FAILED'
};
